import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgKetoconazoleGlyph from './svgs/KetoconazoleGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var ketoconazoleGlyph = (props => useIcon(SvgKetoconazoleGlyph, SvgKetoconazoleGlyph, props));

export { ketoconazoleGlyph as default };
